import RequestList from "../../views/modules/technical_support/requests/RequestList";
import DeviceAssignmentList from "../../views/modules/technical_support/device_assignments/DeviceAssignmentList";
// import ReportNavision from "../../views/modules/technical_support/reports/ReportNavision";
// import ReportGps from "../../views/modules/technical_support/reports/ReportGps";
// import ReportGpsHistory from "../../views/modules/technical_support/reports/ReportGpsHistory.vue";
// import ReportNavixy from "../../views/modules/technical_support/reports/ReportNavixy";
import ListSLA from "../../views/modules/technical_support/SLAConfigurations/ListSLA";
import OrdenTarjetas from "../../views/modules/technical_support/requests/OrdenTarjetas";
// import Kpi from "../../views/modules/technical_support/KPI/Kpi";
import DocumentList from "../../views/modules/technical_support/documents/DocumentList";
import ReportReques from "../../views/modules/technical_support/reports/ReportReques";
//import roles from "@/roles";
// import ReportMagytrack from "../../views/modules/technical_support/reports/ReportMagytrack";
// import Exonerated from "@/views/modules/automatic_processes/cut_and_reconnection/Exonerated.vue";
// import Record from "@/views/modules/automatic_processes/cut_and_reconnection/Record.vue";
// import ReportUsersToCut from "@/views/modules/technical_support/reports/ReportUsersToCut.vue";
import layouts from "../../layout";
//import CutAndReconec from "../../views/modules/operations/CutAndReconec.vue";
import reports from "../../views/modules/operations/reports.vue";
//import kpiTsupport from "../../views/modules/operations/kpiTsupport.vue";
import EquipReport from "../../views/modules/operations/EquipReport.vue";
import InternalR from "@/views/apps/internal_requests/requests/index.vue";
import internalRTech from "@/views/apps/internal_requests/KPI/internalRTech.vue";
import SLA from "@/views/modules/technical_support/KPI/SLA/KpiSoporteTecnico";
import Satisfacción from "@/views/modules/technical_support/KPI/Satisfaccion/KpiSatisfaccion";
// import store from "@/store";
// import { COMPANYS } from "@/const";
//import taller from "../modules/workshop";
import ComparationLinesGps from "@/views/modules/LinesGps/ComparationLinesGps.vue";
import GpsOffLines from "@/views/modules/LinesGps/GpsOfflines.vue";

export default {
  path: "/technical_support",
  name: "technical-support",
  component: () =>
    import(
      /* webpackChunkName: "TechnicalSupport" */ "@/views/modules/technical_support/TechnicalSupport.vue"
    ),
  meta: {
    auth: true
  },
  redirect: {
    name: "technical-support-external-request"
  },
  children: [
    {
      path: "requests",
      name: "technical-support-request",
      component: {
        render: (h) => h("router-view")
      },
      meta: {
        auth: true,
        searchable: true,
        layout: layouts.navLeft,
        title: "Requests",
        tags: ["technicalSupport", "requests"],
        index: true
      },
      children: [
        {
          path: "external-requests",
          name: "technical-support-external-request",
          component: RequestList,
          meta: {
            auth: true,
            searchable: true,
            layout: layouts.navLeft,
            title: "External Requests",
            tags: ["technicalSupport", "external requests"],
            index: true
          }
        },
        {
          path: "kpi-per-support",
          name: "technical-support-kpi-per-support",
          component: SLA,
          meta: {
            auth: true,
            searchable: true,
            layout: layouts.navLeft,
            title: "KPI Cumplimiento SLA",
            tags: ["support", "sla", "list"],
            index: true
          }
        },
        {
          path: "kpi-per-satisfactions",
          name: "technical-support-kpi-per-satisfactions",
          component: Satisfacción,
          meta: {
            auth: true,
            searchable: true,
            layout: layouts.navLeft,
            title: "Satisfactions KPI",
            tags: ["support", "sla", "list"],
            index: true
          }
        },
        {
          path: "sla-configurations",
          name: "technical-support-sla-configurations",
          component: ListSLA,
          meta: {
            auth: true,
            searchable: true,
            layout: layouts.navLeft,
            title: "Device Assignment",
            tags: ["technicalSupport", "slaconfigurations"],
            index: true
          }
        },
        {
          path: "card-requests",
          name: "technical-support-card-requests",
          component: OrdenTarjetas,
          meta: {
            auth: true,
            searchable: true,
            layout: layouts.navLeft,
            title: "Orden Tarjetas",
            tags: ["technicalSupport", "cardOrders", "tarjetas"],
            index: true
          }
        }
      ]
    },
    {
      path: "internal-requests",
      name: "technical-support-internalRequests",
      component: internalRTech,
      meta: {
        auth: true,
        searchable: true,
        layout: layouts.navLeft,
        title: "Mis Solicitudes",
        tags: ["flow", "activity", "activity_flow"],
        index: true
      },

      children: [
        {
          path: "internal-requets",
          name: "technical-support-internal-requests-documentsdctest",
          component: InternalR,
          meta: {
            auth: true,
            searchable: true,
            layout: layouts.navLeft,
            title: "Solicitudes",
            tags: ["internal-requests", "Solicitudes"],
            index: true
          }
        },
        {
          path: "tech-per-support-internal",
          name: "technical-support-tech-requests-kpi-per-support",
          component: () =>
            import("@/views/apps/internal_requests/KPI/SLA/KpiSoporteTecnico"),
          meta: {
            auth: true,
            searchable: true,
            layout: layouts.navLeft,
            title: "SLA",
            tags: ["support", "sla"],
            index: true
          }
        },
        {
          path: "tech-per-satisfactions-internal",
          name: "technical-support-tech-requests-kpi-per-satisfactions",
          component: () =>
            import(
              "@/views/apps/internal_requests/KPI/Satisfaccion/KpiSatisfaccion"
            ),
          meta: {
            auth: true,
            searchable: true,
            layout: layouts.navLeft,
            title: "Satisfaction",
            tags: ["support", "sla"],
            index: true
          }
        },
        {
          path: "Report-per-Responsable-internaltech",
          name: "technical-support-tech-requests-report-per-responsable",
          component: () =>
            import(
              "@/views/apps/internal_requests/KPI/InternalRequestbyResponsable.vue"
            ),
          meta: {
            auth: true,
            searchable: true,
            layout: layouts.navLeft,
            title: "Internals Requests Report",
            tags: ["support", "sla"],
            index: true
          }
        }
      ]
    },
    {
      path: "reports",
      name: "technical-reports",
      component: {
        render: (h) => h("router-view")
      },
      meta: {
        auth: true,
        searchable: true,
        layout: layouts.navLeft,
        title: "Technical Report",
        tags: ["technicalSupport", "deviceAssignment"],
        index: true
      },
      children: [
        {
          path: "reports",
          name: "technical-support-reports",
          component: reports,
          meta: {
            auth: true,
            searchable: true,
            layout: layouts.navLeft,
            title: "Technical Support Report",
            tags: ["technicalSupport", "deviceAssignment"],
            index: true
          }
        },
        {
          path: "device_assignaments",
          name: "technical-support-device-assignments",
          component: DeviceAssignmentList,
          meta: {
            auth: true,
            searchable: true,
            layout: layouts.navLeft,
            title: "Device Assignment",
            tags: ["technicalSupport", "deviceAssignment"],
            index: true
          }
        },
        {
          path: "device_contracts",
          name: "technical-support-Report-Device-Contract",
          component: () =>
            import("@/views/apps/ncfmovil/TerminalsContract.vue"),
          meta: {
            auth: true,
            searchable: true,
            layout: layouts.navLeft,
            title: "Dispositivos por contrato",
            tags: ["technicalSupport", "deviceAssignment"],
            index: true
          }
        },
        {
          path: "DevicesReports",
          name: "devices-reports2",
          component: EquipReport,
          meta: {
            auth: true,
            searchable: true,
            layout: layouts.navLeft,
            title: "Devices Reports",
            tags: ["technicalSupport", "slaconfigurations"],
            index: true
          }
        },
        {
          path: "Audit",
          name: "Audit",
          component: () => import("@/views/modules/operations/AuditMaster.vue"),
          meta: {
            auth: true,
            searchable: true,
            layout: layouts.navLeft,
            title: "Auditoria",
            tags: ["technicalSupport", "slaconfigurations"],
            index: true
          }
        },
        {
          path: "vehicles",
          name: "vehiclesop",
          component: () => import("@/views/modules/operations/vehicleOp.vue"),
          meta: {
            auth: true,
            searchable: true,
            layout: layouts.navLeft,
            title: "vehicle",
            tags: ["technicalSupport", "slaconfigurations"],
            index: true
          }
        }
      ]
    },

    {
      path: "AgendaPre",
      name: "AgendaPre",
      component: () =>
        import("@/views/modules/operations/maintenanceCalen.vue"),
      meta: {
        auth: true,
        searchable: true,
        layout: layouts.navLeft,
        title: "vehicle",
        tags: ["technicalSupport", "slaconfigurations"],
        index: true
      }
    },
    {
      path: "documents",
      name: "technical-support-documents",
      component: DocumentList,
      meta: {
        auth: true,
        searchable: true,
        layout: layouts.navLeft,
        title: "Document",
        tags: ["technical-support", "documents"],
        index: true
      }
    },
    {
      path: "internalrequest",
      name: "technical-report-internalRequests",
      component: ReportReques,
      meta: {
        auth: true,
        searchable: true,
        layout: layouts.navLeft,
        title: "Reporte de Solicitudes",
        tags: ["technical-support", "documents"],
        index: true
      }
    },
    {
      path: "ComparationLinesGps",
      name: "technical-Comparations-linesGps",
      component: ComparationLinesGps,
      meta: {
        auth: true,
        searchable: true,
        layout: layouts.navLeft,
        title: "Lineas Gps",
        tags: ["technical-support", "documents"],
        index: true
      }
    },
    {
      path: "reportsurvey",
      name: "employeestechnical-reportsurvey",
      component: () => import("@/views/modules/SurveyAnswer/ReportSurvey.vue"),
      meta: {
        auth: true,
        searchable: true,
        layout: layouts.navLeft,
        title: "Respuesta de Empleados",
        index: true,
        // Pass props to the component
        props: {
          // Define your props here
          prop1: "value1",
          prop2: "value2"
          // ...,
        }
      }
    },
    {
      path: "GpsOffLines",
      name: "technical-GpsOffLIne",
      component: GpsOffLines,
      meta: {
        auth: true,
        searchable: true,
        layout: layouts.navLeft,
        title: "Gps",
        tags: ["technical-support", "documents"],
        index: true
      }
    },
    {
      path: "controlversion",
      name: "technical-controlversion",
      component: () => import("@/components/technology/ControlVersion.vue"),
      meta: {
        auth: true,
        searchable: true,
        layout: layouts.navLeft,
        title: "Control de versiones",
        index: true,
        // Pass props to the component
        props: {
          // Define your props here
          prop1: "value1",
          prop2: "value2"
          // ...,
        }
      }
    }

    /*
    {
      path: "auto-process",
      name: "technical-support-auto-processnw",
      component: CutAndReconec,
      meta: {
        auth: true,
        searchable: true,
        layout: layouts.navLeft,
        title: "Auto Process",
        tags: ["technicalSupport", "deviceAssignment"],
        index: true
      }
    },
    */

    // {
    //   path: "auto-process",
    //   name: "technical-support-auto-process",
    //   component: {
    //     name: "AutoProcess",
    //     render: (h) => h("router-view")
    //   },
    //   meta: {
    //     auth: true,
    //     title: "Auto Process"
    //   },
    //   children: [
    //     {
    //       path: "exonerated-cut",
    //       name: "technical-support-exonerated-cut",
    //       component: Exonerated,
    //       meta: {
    //         auth: true,
    //         title: "Exonerated Cut",
    //         index: true
    //       }
    //     },
    //     {
    //       path: "record-cut-and-reconnection",
    //       name: "technical-support-record-cut-and-reconnection",
    //       component: Record,
    //       meta: {
    //         auth: true,
    //         title: "Record cut and reconnection",
    //         index: true
    //       }
    //     },
    //     {
    //       path: "report-users-to-cut",
    //       name: "technical-support-report-users-to-cut",
    //       component: ReportUsersToCut,
    //       meta: {
    //         auth: true,
    //         title: "Report users to cut",
    //         index: true
    //       }
    //     }
    //   ]
    // },
    // {
    //   path: "reports",
    //   name: "technical-report",
    //   component: {
    //     render: (h) => h("router-view")
    //   },
    //   meta: {
    //     auth: true
    //   },
    //   redirect: {
    //     name: "technical-report-gps"
    //   },
    //   children: [
    //     {
    //       path: "sims",
    //       name: "technical-report-sims",
    //       component: {
    //         render: (h) => h("router-view")
    //       },
    //       meta: {
    //         auth: true,
    //         index: true
    //       },
    //       redirect: {
    //         name: "technical-report-sims-navision"
    //       },
    //       children: [
    //         {
    //           path: "navision",
    //           name: "technical-report-sims-navision",
    //           component: ReportNavision,
    //           meta: {
    //             auth: true,
    //             searchable: true,
    //             layout: layouts.navLeft,
    //             title: "Report Sims Navision",
    //             tags: ["technicalSupport", "report", "sims", "navision"],
    //             index: true
    //           }
    //         },
    //         {
    //           path: "navixy",
    //           name: "technical-report-sims-navixy",
    //           component: ReportNavixy,
    //           meta: {
    //             auth: true,
    //             searchable: true,
    //             layout: layouts.navLeft,
    //             title: "Report Sims GPS",
    //             tags: ["technicalSupport", "report", "sims", "navixy"],
    //             index: true,
    //             // disable: [COMPANYS.RB, COMPANYS.TB].includes(
    //             //   store.state.user.user.CompanySelected
    //             // ),
    //             disable: store.state.user.user.CompanySelected !== COMPANYS.MTR
    //           }
    //         }
    //       ]
    //     },
    //     {
    //       path: "gps",
    //       name: "technical-report-gps",
    //       component: ReportGps,
    //       meta: {
    //         auth: true,
    //         searchable: true,
    //         layout: layouts.navLeft,
    //         title: "Report GPS",
    //         tags: ["technicalSupport", "report", "gps"],
    //         index: true,
    //         disable: store.state.user.user.CompanySelected !== COMPANYS.MTR
    //       }
    //     },
    //     {
    //       path: "gps-history",
    //       name: "technical-report-gps-history",
    //       component: ReportGpsHistory,
    //       meta: {
    //         auth: true,
    //         searchable: true,
    //         layout: layouts.navLeft,
    //         title: "Report GPS History",
    //         tags: ["technicalSupport", "report", "gps"],
    //         index: true,
    //         disable: store.state.user.user.CompanySelected !== COMPANYS.MTR
    //       }
    //     },
    //     {
    //       path: "gps-mtr",
    //       name: "technical-report-mtr",
    //       component: ReportMagytrack,
    //       meta: {
    //         auth: true,
    //         searchable: true,
    //         layout: layouts.navLeft,
    //         title: "Reporte Magytrack",
    //         tags: ["technicalSupport", "report", "mtr"],
    //         index: true,
    //         disable: store.state.user.user.CompanySelected !== COMPANYS.MTR
    //       }
    //     },
    //     {
    //       path: "technical-report",
    //       name: "technical-report-request",
    //       component: () =>
    //         import(
    //           "@/views/modules/technical_support/reports/ReportByRequest.vue"
    //         ),
    //       meta: {
    //         auth: true,
    //         layout: layouts.navLeft,
    //         title: "Solicitudes de Soporte Tecnico",
    //         index: true
    //       }
    //     },
    //     {
    //       path: "technical-report-Service-requests",
    //       name: "technical-report-techinicals",
    //       component: () =>
    //         import(
    //           "@/views/modules/technical_support/reports/ReportRequestByTechnical.vue"
    //         ),
    //       meta: {
    //         auth: true,
    //         layout: layouts.navLeft,
    //         title: "Solicitudes por tecnico",
    //         index: true
    //       }
    //     },
    //     {
    //       path: "technical-report-users-to-cut",
    //       name: "technical-report-users-to-cut",
    //       component: () =>
    //         import(
    //           "@/views/modules/technical_support/reports/ReportUsersToCut"
    //         ),
    //       meta: {
    //         auth: true,
    //         layout: layouts.navLeft,
    //         title: "Reporte de clientes a cortar",
    //         index: true
    //       }
    //     },
    //     {
    //       path: "technical-report-maintenance-chip",
    //       name: "technical-report-maintenance-chip",
    //       component: () =>
    //         import(
    //           "@/views/modules/technical_support/reports/ReportMaintenanceChip.vue"
    //         ),
    //       meta: {
    //         auth: true,
    //         layout: layouts.navLeft,
    //         title: "Reporte Mantenimiento de CHIP",
    //         index: true
    //       }
    //     }
    //   ]
    // },

    /*
    {
      path: "kpisla2",
      name: "kpisla2",
      component: kpiTsupport,
      meta: {
        auth: true,
        searchable: true,
        layout: layouts.navLeft,
        title: "KPI",
        tags: ["technicalSupport", "slaconfigurations"],
        index: true
      }
    },
    */

    /*
    {
      path: "TallerS",
      name: "workshopT",
      component: () => import("@/views/modules/operations/Taller.vue"),
      meta: {
        auth: true,
        searchable: true,
        layout: layouts.navLeft,
        title: "Taller",
        tags: ["technicalSupport", "slaconfigurations"],
        index: true
      }
    },
    {
      path: "ProjectsO",
      name: "projectso",
      component: () => import("@/views/modules/operations/projectOp.vue"),
      meta: {
        auth: true,
        searchable: true,
        layout: layouts.navLeft,
        title: "Auditoria",
        tags: ["technicalSupport", "slaconfigurations"],
        index: true
      }
    },
    */

    // {
    //   path: "kpisla",
    //   name: "kpisla",
    //   component: Kpi,
    //   meta: {
    //     auth: true,
    //     searchable: true,
    //     layout: layouts.navLeft,
    //     title: "KPI",
    //     tags: ["support", "kpi"],
    //     index: true
    //   },
    //   children: [
    //     {
    //       path: "kpi-per-support",
    //       name: "technical-support-kpi-per-support",
    //       component: () =>
    //         import(
    //           "../../views/modules/technical_support/KPI/SLA/KpiSoporteTecnico"
    //         ),
    //       meta: {
    //         auth: true,
    //         searchable: true,
    //         layout: layouts.navLeft,
    //         title: "KPI Cumplimiento SLA",
    //         tags: ["support", "sla", "list"],
    //         index: true
    //       }
    //     },
    //     {
    //       path: "kpi-per-satisfactions",
    //       name: "technical-support-kpi-per-satisfactions",
    //       component: () =>
    //         import(
    //           "../../views/modules/technical_support/KPI/Satisfaccion/KpiSatisfaccion"
    //         ),
    //       meta: {
    //         auth: true,
    //         searchable: true,
    //         layout: layouts.navLeft,
    //         title: "Satisfactions KPI",
    //         tags: ["support", "sla", "list"],
    //         index: true
    //       }
    //     }
    //   ]
    // },
    // {
    //   path: "DevicesReports",
    //   name: "devices-reports",
    //   component: {
    //     render: (h) => h("router-view")
    //   },
    //   meta: {
    //     auth: true,
    //     title: "Devices Reports"
    //   },
    //   children: [
    //     {
    //       path: "report-devices-gps",
    //       name: "report-gps-by-client-technical_support",
    //       component: () =>
    //         import("../../views/modules/sales/reports/ReportDevicesByClients"),
    //       meta: {
    //         auth: true,
    //         searchable: true,
    //         layout: layouts.navLeft,
    //         title: "Reporte Equipos Por Cliente",
    //         tags: ["report", "technical", "support", "list", "devices"],
    //         index: true
    //       }
    //     },
    //     {
    //       path: "traccar-report-devices-gps",
    //       name: "traccar-report-gps-by-client-technical_support",
    //       component: () =>
    //         import(
    //           "../../views/modules/technical_support/reports/TraccarGpsReport.vue"
    //         ),
    //       meta: {
    //         auth: true,
    //         searchable: true,
    //         layout: layouts.navLeft,
    //         title: "Reporte GPS Por Cliente Plataforma Traccar",
    //         tags: [
    //           "report",
    //           "technical",
    //           "support",
    //           "list",
    //           "devices",
    //           "gps",
    //           "traccar"
    //         ],
    //         index: true
    //       }
    //     },
    //     {
    //       path: "report-terminals",
    //       name: "report-terminals-by-client-technical_support",
    //       component: () => import("../../components/reports/ReportTerminals"),
    //       meta: {
    //         auth: true,
    //         searchable: true,
    //         layout: layouts.navLeft,
    //         title: "Reporte Terminales Por Cliente",
    //         tags: [
    //           "report",
    //           "technical",
    //           "support",
    //           "list",
    //           "devices",
    //           "terminales"
    //         ],
    //         index: true
    //       }
    //     },
    //     {
    //       path: "report-count-terminal",
    //       name: "report-terminals-company",
    //       component: () =>
    //         import("../../components/reports/ReportesCantidadTerminales"),
    //       meta: {
    //         auth: true,
    //         searchable: true,
    //         layout: layouts.navLeft,
    //         title: "Reporte Cantidad Terminales",
    //         tags: [
    //           "report",
    //           "technical",
    //           "support",
    //           "list",
    //           "devices",
    //           "terminales"
    //         ],
    //         index: true
    //       }
    //     }
    //   ]
    // }
  ]
};
